import { connectorsForWallets } from '@rainbow-me/rainbowkit';
import { abstractWalletConnector } from '@abstract-foundation/agw-react/connectors';
import {
  metaMaskWallet,
  okxWallet,
  coinbaseWallet,
  rabbyWallet,
  phantomWallet,
  walletConnectWallet,
} from '@rainbow-me/rainbowkit/wallets';
import { createConfig } from 'wagmi';
import { createClient, http } from 'viem';
import { eip712WalletActions } from 'viem/zksync';
import {
  abstract,
  arbitrum,
  avalanche,
  base,
  berachain,
  bsc,
  mainnet,
  mantle,
  mode,
  monad,
  morph,
  optimism,
  plumeMainnet,
  polygon,
  sei,
  sonic,
  story,
} from 'wagmi/chains';

const appUrl =
  import.meta.env.VITE_APP_URL ??
  (typeof window !== 'undefined' ? window.location.origin : 'http://localhost:5173');
const appIcon = new URL('/favicon.svg', appUrl).toString();
const walletConnectProjectId = import.meta.env.VITE_WALLETCONNECT_PROJECT_ID ?? 'PLACEHOLDER';

export const evmChains = [
  arbitrum,
  optimism,
  base,
  mainnet,
  monad,
  bsc,
  polygon,
  sonic,
  sei,
  story,
  abstract,
  morph,
  mantle,
  mode,
  avalanche,
  berachain,
  plumeMainnet,
] as const;

export const SUPPORTED_EVM_CHAIN_IDS = new Set<number>(evmChains.map((chain) => chain.id));

const connectors = connectorsForWallets(
  [
    {
      groupName: 'EVM',
      wallets: [
        metaMaskWallet,
        walletConnectWallet,
        okxWallet,
        coinbaseWallet,
        rabbyWallet,
        phantomWallet,
      ],
    },
  ],
  {
    appName: 'Emergency Exit',
    appDescription: 'Emergency exit tool for closing positions and withdrawing funds from a DEX.',
    appUrl,
    appIcon,
    projectId: walletConnectProjectId,
  },
);

export const wagmiConfig = createConfig({
  chains: evmChains,
  connectors: [...connectors, abstractWalletConnector()],
  client({ chain }) {
    return createClient({ chain, transport: http() }).extend(eip712WalletActions());
  },
});
